'use client'

import { ErrorBoundary } from '@/app/_components/error/ErrorBoundary'

export default ErrorBoundary
